jQuery(function ($) {
    $('.sg-load-more').click(function () {
        var button = $(this);
        var txt = button.html();

        var data = {
            action: sg_loadmore_params.action,
            call_fun: sg_loadmore_params.call_fun,
            current_page: parseInt(sg_loadmore_params.current_page),
            template: sg_loadmore_params.template,
            sg_query_vars: sg_loadmore_params.sg_query_vars,
            console_type: sg_loadmore_params.console_type,
            post_not_in: sg_loadmore_params.loaded_ids,
            more_posts_nonce: $('#more_posts_nonce').val(),
            lazyLoad: false,
        };

        $.ajax({
            url: sg_loadmore_params.ajaxurl,
            data: data,
            type: 'POST',
            beforeSend: function (xhr) {
                button.text('جار التحميل');
                button.prop('disabled', true);
            },
            success: function (result) {
                if (result.data != '') {
                    if ($('.b-load-more--content .b-load-more').length) {
                        $(result.data).insertBefore(
                            '.b-load-more--content .b-load-more'
                        );
                    } else {
                        $('.b-load-more--content').append(result.data);
                    }

                    sg_loadmore_params.current_page++;
                    button.text(txt);
                    button.prop('disabled', false);

                    disqus_comments.get_count();

                    if (
                        sg_loadmore_params.current_page ==
                        sg_loadmore_params.max_page
                    ) {
                        button.remove();
                    }
                } else {
                    button.remove(); // if no data, remove the button as well
                }
            },
        });
    });
});
